/**
 * Central config and cell render helpers for Device update logs ({@link DeviceUpdateLogs} + {@link ConfiguredDataTable}).
 * Timestamp filter strings must match displayed {@link Moment} format so substring filters behave intuitively.
 */
import React from "react";
import { Box } from "@mui/material";
import Moment from "react-moment";

/** Same chronological value as UI list (DD-MM-YYYY HH:mm:ss) so filter text matches rendered cells. */
export const formatDeviceLogTimestamp = (value) => {
  if (!value) return "";
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return String(value);
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(dt.getDate())}-${pad(dt.getMonth() + 1)}-${dt.getFullYear()} ${pad(
    dt.getHours()
  )}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;
};

/** Mirrors API field keys; renderType selects an entry in deviceUpdateLogRenderers. */
export const deviceUpdateLogsTableConfig = {
  columnSequence: [
    "serialNumber",
    "activity",
    "timestamp",
    "productSerialNumber",
    "macAddress",
    "status",
  ],
  defaultVisibleColumns: [
    "serialNumber",
    "activity",
    "timestamp",
    "productSerialNumber",
    "macAddress",
    "status",
  ],
  columns: {
    serialNumber: {
      label: "S.No",
      sortable: false,
      filterable: false,
      minWidth: 100,
      renderType: "text",
    },
    activity: {
      label: "Actions",
      sortable: false,
      filterable: true,
      minWidth: 160,
      renderType: "text",
    },
    timestamp: {
      label: "Timestamp",
      sortable: true,
      filterable: true,
      minWidth: 180,
      renderType: "timestamp",
    },
    productSerialNumber: {
      label: "Product Serial Number",
      sortable: true,
      filterable: true,
      minWidth: 220,
      renderType: "text",
    },
    macAddress: {
      label: "MAC Address",
      sortable: false,
      filterable: true,
      minWidth: 200,
      renderType: "text",
    },
    status: {
      label: "Status",
      sortable: true,
      filterable: true,
      minWidth: 280,
      renderType: "text",
    },
  },
};

const renderTextCell = (value, row, key) => {
  const cellValue = key === "serialNumber" ? row.serialNumber : value;
  const strVal = String(cellValue || "");
  const breakWord = key !== "serialNumber" && strVal.length > 200;

  return (
    <Box className={breakWord ? "breakWord" : strVal.length > 60 ? "breakWord" : ""}>
      {cellValue || ""}
    </Box>
  );
};

const renderTimestampCell = (value) => {
  const strVal = String(value || "");
  return strVal && strVal.length > 0 ? (
    <Box className={strVal.length > 60 ? "breakWord" : ""}>
      <Moment format="DD-MM-YYYY HH:mm:ss" date={value} />
    </Box>
  ) : (
    ""
  );
};

export const deviceUpdateLogRenderers = {
  text: renderTextCell,
  timestamp: renderTimestampCell,
};

